import { EmployeeLiteModel } from 'api-hooks/employee';
import { ProductVariantModel } from 'api-hooks/product/list';
import { TourOtherPriceModel } from 'api-hooks/tour/tour-sale';
import { Expose, Type } from 'class-transformer';
import { TourStatusEnum } from 'common/constants/enum';
import { CommonParamInput } from 'common/repositories/common.model';

import { FlightModel } from '../flight/model';
import { HotelTourModel } from '../hotel/model';

export enum TourParticipantTypeEnum {
  adult = 'adult',
  children = 'children',
}

export enum OtherPricesDescriptionEnum {
  visa = 'visa',
  airportTax = 'airport_tax',
}

export class TourPriceModel {
  type: string | null;
  id: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'is_default' })
  isDefault: boolean;

  @Type(() => Number)
  price: number;
}

export class OtherPricesModel {
  description: string | null;
  id: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Type(() => Number)
  price: number;
}

export class TourLiteModel {
  id: string;
  code: string | null;
  type: string | null;
  status: string;
  name: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;
}

export class CategoryModel {
  id: string;
  name: string;
  description: string;
}

export class TourProductModel {
  description: string | null;
  id: string;

  @Expose({ name: 'complete_name' })
  completeName: string;

  @Expose({ name: 'product_variant' })
  @Type(() => ProductVariantModel)
  productVariant: ProductVariantModel;

  @Type(() => Number)
  qty: number;

  @Expose({ name: 'ref_id' })
  refId: string;
}

export class TourModel {
  id: string;
  code: string | null;
  name: string;
  description: string;
  day: number;
  night: number;
  status: TourStatusEnum;
  type: string;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Type(() => EmployeeLiteModel)
  admin: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  operator: EmployeeLiteModel;

  @Type(() => EmployeeLiteModel)
  salesman: EmployeeLiteModel;

  @Type(() => CategoryModel)
  category: CategoryModel;

  @Expose({ name: 'admin_commission' })
  @Type(() => Number)
  adminCommission: number;

  @Expose({ name: 'operator_commission' })
  @Type(() => Number)
  operatorCommission: number;

  @Expose({ name: 'sales_commission' })
  @Type(() => Number)
  salesCommission: number;

  @Expose({ name: 'tour_prices' })
  @Type(() => TourPriceModel)
  tourPrices: TourPriceModel[];

  @Expose({ name: 'tour_other_prices' })
  @Type(() => TourOtherPriceModel)
  tourOtherPrices: OtherPricesModel[] | [];

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'started_at' })
  @Type(() => Date)
  startedAt: Date;

  @Expose({ name: 'ended_at' })
  @Type(() => Date)
  endedAt: Date;

  @Expose({ name: 'tour_flights' })
  @Type(() => FlightModel)
  tourFlights: FlightModel[];

  @Expose({ name: 'tour_hotels' })
  @Type(() => HotelTourModel)
  tourHotels: HotelTourModel[];

  @Expose({ name: 'tour_products' })
  @Type(() => TourProductModel)
  tourProducts: TourProductModel[];

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

export class getToursInput {
  params: CommonParamInput;
}

export class getTourInput {
  id: string;
}
export class TourOtherPriceMutationInput {
  refId?: string;
  price: number;
  description: string;
}

export class TourPriceMutationInput {
  refId?: string;
  type: string;
  price: number;
  isDefault: boolean;
}

export class TourFlightAirlineMutationInput {
  airlineId: string;
  preferenceId: string;
  date: Date;
  detail: string;
  route: string;
  time: string;
}
export class TourFlightMutationInput {
  refId?: string;
  name: string;
  note: string;
  tourFlightAirlines: TourFlightAirlineMutationInput[];
}

export class TourProductMutationInput {
  refId?: string;
  productVariantId: string;
  qty: number;
  description: string;
}

export class TourHotelDetailMutationInput {
  checkIn: Date;
  checkOut: Date;
  night: number;
  hotelRoomId: string;
  cityTax: string;
  description: string;
}

export class TourHotelMutationInput {
  refId?: string;
  hotelId?: string;
  note: string;
  details: TourHotelDetailMutationInput[];
}

export class TourMutationInput {
  name: string;
  type: string;
  code: string;
  transactionAt: Date;
  needApproval: boolean;
  description: string;
  startedAt: Date;
  endedAt: Date;
  day: number;
  tourCategoryId: string;
  employeeId: string;
  operatorId: string;
  salesmanId: string;
  adminCommission: number;
  operatorCommission: number;
  salesCommission: number;
  tourPrices: TourPriceMutationInput[];
  tourOtherPrices: TourOtherPriceMutationInput[];
  tourFlights: TourFlightMutationInput[];
  tourProducts: TourProductMutationInput[];
  tourHotels: TourHotelMutationInput[];
}

export class TourUpdateInput {
  tourId: string;
  body: TourMutationInput;
}

export class TourDeleteInput {
  tourId: string;
}
